import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";

// Register a font if you need custom fonts (optional but recommended for consistency)
// You would need to load your font files.
// Font.register({ family: 'Roboto', src: '/fonts/Roboto-Regular.ttf' });
// Font.register({ family: 'Roboto', src: '/fonts/Roboto-Bold.ttf', fontWeight: 'bold' });

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 12,
    backgroundColor: "#f8f9fa",
    color: "#333",
    fontFamily: "Helvetica",
  },
  header: {
    flexDirection: "column",
    alignItems: "center",
    marginBottom: 30,
    paddingBottom: 15,
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    borderBottomStyle: "solid",
  },
  projectName: {
    fontSize: 24,
    fontWeight: "bold",
    marginBottom: 5,
    color: "rgb(81, 154, 204)",
  },
  reportDate: {
    fontSize: 14,
    color: "#555",
  },
  metricsContainer: {
    flexDirection: "row",
    justifyContent: "space-around",
    marginBottom: 30,
    flexWrap: "wrap",
  },
  metricBox: {
    width: "30%",
    backgroundColor: "#fff",
    padding: 20,
    borderRadius: 8,
    border: "1px solid #e0e0e0",
    alignItems: "center",
    textAlign: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 4,
    marginBottom: 15,
  },
  metricIcon: {
    width: 40,
    height: 40,
    marginBottom: 15,
  },
  metricValue: {
    fontSize: 28,
    fontWeight: "bold",
    marginBottom: 5,
    color: "rgb(81, 154, 204)",
  },
  metricLabel: {
    fontSize: 12,
    color: "#555",
    textTransform: "uppercase",
  },
  notesSection: {
    marginBottom: 20,
    paddingTop: 15,
    borderTopWidth: 1,
    borderTopColor: "#ccc",
    borderTopStyle: "solid",
  },
  notesLabel: {
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 8,
    color: "#333",
  },
  notesValue: {
    fontSize: 12,
    lineHeight: 1.5,
    color: "#555",
  },
});

export const PDFDocument = ({
  projectName,
  reportDate,
  pmNotes,
  bugsFiled,
  stepsCompleted,
  devicesTested,
}) => (
  <Document>
    <Page size="A4" style={styles.page}>
      {/* Header */}
      <View style={styles.header}>
        <Text style={styles.projectName}>{projectName}</Text>
        <Text style={styles.reportDate}>Report for {reportDate}</Text>
      </View>

      {/* Key Metrics Section */}
      <View style={styles.metricsContainer}>
        {/* Bugs Filed Box */}
        <View style={styles.metricBox}>
          <Image style={styles.metricIcon} src="/Icons_Bugs_Filled.png" />
          <Text style={styles.metricValue}>{bugsFiled}</Text>
          <Text style={styles.metricLabel}>Bugs Filed</Text>
        </View>

        {/* Steps Completed Box */}
        <View style={styles.metricBox}>
          <Image style={styles.metricIcon} src="/Icons_Test_Cases_Filled.png" />
          <Text style={styles.metricValue}>{stepsCompleted}</Text>
          <Text style={styles.metricLabel}>Steps Completed</Text>
        </View>

        {/* Devices Tested Box */}
        <View style={styles.metricBox}>
          <Image style={styles.metricIcon} src="/Icons_Device_Lab_Filled.png" />
          <Text style={styles.metricValue}>{devicesTested}</Text>
          <Text style={styles.metricLabel}>Devices Tested</Text>
        </View>
      </View>

      {/* PM Notes Section */}
      <View style={styles.notesSection}>
        <Text style={styles.notesLabel}>Notes from the Project Manager:</Text>
        {/* Handle potential null/undefined pmNotes */}
        <Text style={styles.notesValue}>{pmNotes || "No notes provided."}</Text>
      </View>
    </Page>
  </Document>
);
